<template>
  <div
    class="service-list-item"
    :class="{ 'service-list-item--with-border': showTopBorder }">
    <!-- Icon slot -->
    <div class="service-list-item__icon">
      <slot name="icon"></slot>
    </div>

    <!-- Text content -->
    <span class="service-list-item__text">
      {{ text }}
    </span>
  </div>
</template>

<script setup>
// Props
  defineProps({
    text: {
      type: String,
      required: true,
      validator: value => typeof value === 'string' && value.trim().length > 0
    },
    showTopBorder: {
      type: Boolean,
      default: false
    }
  })
</script>

<style lang="scss" scoped>
.service-list-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--space-n); // 32px gap
  // padding: var(--space-s) 0; // vertical padding, no horizontal
  width: 100%;
  box-sizing: border-box;

  &--with-border {
    border-top: 1px solid var(--color-grey);
    padding-top: var(--space-s); // Add extra space-s on top when border is present
  }

  &__icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px; // 32px icon + 16px padding on each side
    height: 64px; // 32px icon + 16px padding on each side
    background: var(--color-light-grey);
    border-radius: 8px;
    padding: 16px;

    svg {
      display: block;
      width: 32px;
      height: 32px;
    }
  }

  &__text {
    font-family: var(--font-family-poppins);
    font-size: var(--typography-size-m, 20px);
    font-weight: 400;
    line-height: 160%; /* 32px */
    color: var(--color-black);
    margin: 0;

    @include mq($until: tablet) {
      font-size: 18px;
      line-height: 150%;
    }

    @include mq($until: mobile) {
      font-size: 16px;
      line-height: 140%;
    }
  }

  // Responsive gap adjustment
  @include mq($until: tablet) {
    flex-direction: row; // Force row layout on tablet
    gap: var(--space-s); // 24px on tablet
  }

  @include mq($until: mobile) {
    flex-direction: row; // Force row layout on mobile
    gap: var(--space-xs); // 16px on mobile
  }
}
</style>
